import { AppTheme } from '../constants/common';

interface EventsProps {
	THEME: AppTheme;
	LOGOUT: boolean;
	LOGIN: {
		id: number;
	};
}

export const reactNativeEvent = () => {
	const send = (eventName: keyof EventsProps, eventData?: any) => {
		const data = { eventName: eventName, eventData: eventData };
		window.ReactNativeWebView?.postMessage?.(JSON.stringify(data));
	};

	return {
		send,
	};
};
